import React from 'react'
import {FormattedNumber} from 'react-intl'
import styled from '@emotion/styled'
import {OfferLogo} from 'components/Offer/Shared/OfferLogo'

import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

interface PriceTrendRedirectLayoutProps {
  offer: SearchOffer
  hotelId: string
  priceValue: number
  currency: string | null
}

const NUMBER_OF_DECIMALS_FOR_PRICE = 0

const RedirectWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s400};
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s400};
`

/**
 * Layout component for mobile redirect offers in PriceTrend.
 * Displays: Provider Logo | Price | "View deal" button
 */
export const PriceTrendRedirectLayout = ({
  offer,
  hotelId,
  priceValue,
  currency
}: PriceTrendRedirectLayoutProps) => (
  <Box>
    <RedirectWrapper>
      <LeftSection>
        <OfferLogo hotelId={hotelId} offer={offer} variant="logo" />
      </LeftSection>
      <RightSection>
        <Text variant="titleL" colorPath="content.neutral.primary">
          <FormattedNumber
            currency={currency}
            style="currency"
            minimumFractionDigits={NUMBER_OF_DECIMALS_FOR_PRICE}
            maximumFractionDigits={NUMBER_OF_DECIMALS_FOR_PRICE}
            value={priceValue}
          />
        </Text>
        <Button
          dataId="price-trend-redirect-button"
          iconEnd={<Icon name="ChevronRight" />}
        >
          <FormattedMessageWrapper id="viewDeal" defaultMessage="View deal" />
        </Button>
      </RightSection>
    </RedirectWrapper>
  </Box>
)
